<template>
  <div class="ushk-wrap ushk-wrap-main">
    <div class="ushk-price ushk-content-box">
      <div class="ushk-price__wrap">
        <div class="ushk-price__b">
          <div
            id="J_price_marquee"
            class="ushk-price__marquee marquee3k"
            data-pausable="true"
            data-speed="0.8"
          >
            <div v-for="n in wrapNum" class="ushk-price__group J_price_group">
              <div
                v-for="(value, key) in datas"
                :key="key"
                class="ushk-price__item J_price_item"
                :data-code="key"
              >
                <div class="ushk-price__content">
                  <h5 class="ushk-price__name">
                    {{ value.name }}
                    <span>{{ key }}</span>
                  </h5>
                  <div class="ushk-price__value">
                    <span
                      :style="{color: value.bTextColor, 'background-color': value.bgColor}"
                      >{{ value.bValue || '--' }}</span
                    >
                  </div>
                  <div class="ushk-price__value">
                    <span :style="{color: value.textColor}"
                      >{{ value.pValue || '--' }}</span
                    >
                    <i
                      class="ushk-icon"
                      :class="'ushk-icon_' + value.dir"
                      :style="{color: value.textColor}"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { priceOptionDatas, subscription } from './option'
  import Socket from '@/plugins/socket'
  import { addScript } from '@/commons/utils'
  import { device } from '@/commons'
  import Marquee3k from '@/plugins/marquee'

  let $socket = null
  function filterMessage (val) {
    return val.toFixed(2)
  }

  export default {
    name: '',
    props: {},
    data () {
      return {
        datas: priceOptionDatas,
        wrapNum: 2,
        groupNum: 8,
        timer: {},
        locations: [],
        curLocation: 0,
        subscribeText: [],
        subscribeIndex: 0,
        initedMerquee: false,
        marqueeWidth: 0
      }
    },
    watch: {
      subscribeText (v) {
        let delIndex = 0
        let index = this.subscribeIndex
        if (index >= 2 && index < this.groupNum) {
          delIndex = index - 2
        } else if (index === 0) {
          delIndex = this.groupNum - 2
        } else {
          delIndex = this.groupNum - index
        }
        if ($socket) {
          $socket.emit(
            'delAllSubscription',
            this.locations[delIndex].subscription
          )
          $socket.emit('addSubscription', v)
        }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        if (device.isMobile) {
          return false
        }
        if (process.env.NODE_ENV !== 'development') {
          $socket = new Socket({
            jsUrl: 'https://www.jin10.com/js/pserver.js',
            jsName: 'pServerArr'
          })
          this.onSocket()
        }
      },
      onSocket () {
        $socket &&
          $socket.connection.then(socket => {
            socket.on('connect', this.connect)
            socket.on('price list', msg => {
              this.update(msg)
            })
          })
      },
      initMarquee () {
        this.getLocation()
        this.marqueeWidth = document.getElementById(
          'J_price_marquee'
        ).offsetWidth
        if (this.initedMerquee) {
          return false
        }
        this.initedMerquee = true
        setTimeout(() => {
          Marquee3k.init({
            selector: 'marquee3k',
            isCustomContent: true,
            wrapper: document.querySelector('.ushk-price__marquee'),
            callback: ({ offset, width }) => {
              offset = Math.floor(Math.abs(offset))
              if (offset > width - this.marqueeWidth) {
                if (this.curLocation) {
                  this.curLocation = 0
                  this.subscribeIndex = 0
                  this.subscribeText = this.locations[0].subscription
                }
              } else {
                this.locations.forEach((item, i) => {
                  if (
                    offset === item.left - this.marqueeWidth &&
                    offset !== this.curLocation
                  ) {
                    this.curLocation = item.left
                    this.subscribeText = item.subscription
                    this.subscribeIndex = i
                  }
                })
              }
            }
          })
        }, 4000)
      },
      connect () {
        const subscribeText = this.locations[this.subscribeIndex]
          ? this.locations[this.subscribeIndex].subscription
          : subscription.slice(0, this.groupNum)
        $socket.emit('delAllSubscription', [])
        $socket.emit('addSubscription', subscribeText)
        $socket.emit('reg', 'ok')
        setTimeout(() => {
          this.initMarquee()
        }, 1000)
      },
      update (msg) {
        var name = msg.name
        if (!this.datas[name]) {
          return false
        }
        var newValue = msg.v.lp
        var oldValue = this.datas[name] && this.datas[name].bValue
        var bgColor
        var textColor = 'grey'
        var dirP

        if (Number(newValue) > Number(oldValue)) {
          bgColor = '#e24052'
        } else if (Number(newValue) < Number(oldValue)) {
          bgColor = '#36a984'
        } else if (Number(newValue) == Number(oldValue)) {
          return
        }
        if (msg.v.ch != null) {
          var per = (msg.v.ch / (msg.v.lp - msg.v.ch)) * 100
          if (Number(per) > 0) {
            textColor = '#e24052'
            dirP = 'up'
          } else if (Number(per) < 0) {
            textColor = '#36a984'
            dirP = 'down'
          } else {
            textColor = '#fff'
          }
          this.datas[name].textColor = textColor
          this.datas[name].bTextColor = textColor
          this.datas[name].pValue = filterMessage(per) + '%'
          this.datas[name].dir = dirP
        }
        var id = null
        if (typeof this.timer[name] === 'undefined') {
          this.timer[name] = null
        }
        id = this.timer[name]
        if (id != null && id != 0) {
          clearTimeout(id)
        }
        this.datas[name].bgColor = bgColor
        this.datas[name].bTextColor = '#fff'
        this.datas[name].bValue = filterMessage(parseFloat(msg.v.lp))

        var mm = setTimeout(() => {
          this.datas[name].bgColor = 'transparent'
          this.datas[name].bTextColor = this.datas[name].textColor
          this.timer[name] = 0
        }, 600)
        this.timer[name] = mm
      },
      getLocation () {
        const $group = Array.from(
          document.querySelectorAll('.J_price_group')
        )[0]
        const $items = Array.from($group.querySelectorAll('.J_price_item'))
        const length = $items.length
        const groupNum = this.groupNum
        const itemNum = Math.floor(length / groupNum)
        const remainder = length % groupNum
        let locations = []
        this.locations = []
        $items.forEach(item => {
          locations.push(item.offsetLeft)
        })
        for (let i = 0; i < groupNum; i++) {
          const groupIndex = itemNum * i
          let num = itemNum * (i + 1)
          if (i + 1 === groupNum && remainder) {
            num += remainder
          }
          this.locations.push({
            left: Math.floor(locations[groupIndex]),
            subscription: subscription.slice(groupIndex, num)
          })
        }
        // this.subscribeText = this.locations[0].subscription
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?6b4ec328